import React, { ReactNode } from 'react';
// import { useAttachEvent } from './utils/useAttachEvents';
interface ElementsContextValue {
xpay: any;
}

declare global {
  interface Window {
      Xpay:any;
  }
}

const ElementsContext = React.createContext<ElementsContextValue | null>(null);
ElementsContext.displayName = 'ElementsContext';

export const parseElementsContext = (
  ctx: ElementsContextValue | null,
  useCase: string
): ElementsContextValue => {
  if (!ctx) {
    throw new Error(
      `Could not find XPay context; You need to wrap the part of your app that ${useCase} in an <XPay> provider.`
    );
  }

  return ctx;
};

// interface ElementsProps {
//   xpay: any;
//   options?: any;
// }

export type UnknownOptions = {[k: string]: unknown};

interface xpay {
  publishableKey: string;
  hmacSecret: string;
  accountId: string;
}

interface PrivateElementsProps {
  xpay: xpay;
  children: ReactNode;
}

const CDN = 'https://js.xstak.com/xpay-stage.js'

export const XPay = ({xpay, children}: PrivateElementsProps): any => {
const existingScript = document.querySelector(`script[src$="${CDN}"]`);
    if (!existingScript) {
        console.error(
            `XPay CDN not present. Perhaps you forgot to add <script src="${CDN}"></script> to your index.html file.`
        );
        return;
    }
  const xpayy = new window.Xpay(
    xpay.publishableKey,
    xpay.accountId,
    xpay.hmacSecret,
  );
  const [ctx, setContext] = React.useState<ElementsContextValue>(() => ({
      xpay: xpayy,
    }));

    React.useEffect(() => {
       /* tslint:disable:no-unused-variable */
      // let isMounted = true;
  
        setContext((ctx) => {
         
          if (ctx.xpay) return ctx;
          return {
            xpay: xpayy,
          };
        });
  
      // return () => {
        // isMounted = false;
      // };
    }, [ctx]);

    return (
      <ElementsContext.Provider value={ctx}>
          {children}
      </ElementsContext.Provider>
    );
}

export const useElementsContextWithUseCase = (
  useCaseMessage: string
): ElementsContextValue => {
  const ctx = React.useContext(ElementsContext);
  return parseElementsContext(ctx, useCaseMessage);
};

export const useXpay = (): any => {
  const { xpay } = useElementsContextWithUseCase('calls useXpay()');
  return xpay;
};
